import React from "react";
import "./HeroComponents.css";
import { MdArrowForward } from "react-icons/md";
import { Link as LinkR } from "react-router-dom";
const HeroSection = () => {
  return (
    <header className="hero">
      <div className="container hero__wrapper">
        <div className="hero__grid">
          <h1 className="hero__text animate-pop-in">
            Join
            <br></br>
            <span> TSS Club </span>
          </h1>
          <h3 class="animate-pop-in">
            Play <span>
              the beautiful game
            </span>
          </h3>
          <p class="animate-pop-in">
            New events every week! Click the button below to register.
          </p>
          <a href="https://forms.gle/twXAvVC4xdCUcnn7A"  className="btn primary animate-pop-in btn--animated" target={"_blank"}>
            Register <MdArrowForward />
          </a>
        </div>
      </div>
    </header>
  );
};

export default HeroSection;
